export const CHECKOUT_DEFAULT_LOADING_TEXT: string[] = [
    'availability.first',
    'availability.second',
    'availability.third',
    'availability.fourth'
];

export const CHECKOUT_CREATE_DEAL_LOADING_TEXT: string[] = [
    'createDeal.first',
    'createDeal.second',
    'createDeal.first',
    'createDeal.second'
];

export const CHECKOUT_NOTIFY_LOADING_TEXT: string[] = [
    'notify.first',
    'notify.second',
    'notify.third',
    'notify.first',
];
